import axios from "axios";
import Role from "../classes/api/Role";

/**
 * Fetches all roles from the API.
 *
 * This asynchronous function retrieves role data from the API endpoint `/api/roles`
 * and maps the data to an array of Role instances. Each role includes properties
 * such as id, name, description, and active status.
 *
 * @returns {Promise<Role[]>} A promise that resolves to an array of Role instances.
 * @throws Will throw an error if the API request fails or an issue occurs during processing.
 */
export const fetchAll = async (): Promise<Role[]> => {
    try {
        const {data} = await axios.get('/api/roles');

        return data.map((item: any) => Role.fromJson(item));
    } catch (error) {
        console.error('Erreur lors de la récupération des roles', error);
        throw error;
    }
};